import Rest from '../Rest'

export default class InfluencerService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/influencers'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  /** Cadastro pelo admin: cria usuário, pessoa e influencer — pendente de aprovação. */
  register(payload: any) {
    return this.post('/register', payload)
  }

  /** Fila de aprovação — pendentes, mais antigos primeiro. */
  pending() {
    return this.get('/pending')
  }

  approve(id: number) {
    return this.put(`/${id}/approve`, {})
  }

  reject(id: number, reason: string) {
    return this.put(`/${id}/reject`, { reason })
  }

  suspend(id: number, reason: string) {
    return this.put(`/${id}/suspend`, { reason })
  }

  reactivate(id: number) {
    return this.put(`/${id}/reactivate`, {})
  }

  saveSocialProfiles(id: number, profiles: any[]) {
    return this.put(`/${id}/social_profiles`, { profiles })
  }

  saveGroups(id: number, groupIds: number[]) {
    return this.put(`/${id}/groups`, { group_ids: groupIds })
  }

  refreshLevel(id: number) {
    return this.put(`/${id}/refresh_level`, {})
  }
}
